<template>
  <v-content>
    <v-container fluid>
      <v-layout row justify-center>
        <v-flex xs12 sm8 lg6>
          <v-card class="mt-3 pa-3" color="grey lighten-3">
            <v-card-title primary-title>
              <div class="headline">Recupera tu cuenta</div>
            </v-card-title>
            <v-card-text>
              <v-layout row justify-center>
                <v-flex xs10>
                  <v-form v-model="valid" ref="form">
                    <v-subheader>Introduce el correo electrónico para buscar tu cuenta.</v-subheader>
                    <v-layout row justify-center>
                      <v-flex xs11>
                        <v-text-field
                          label="Correo electrónico"
                          :rules="emailAddressRules"
                          v-model="emailAddress"
                          required
                        />
                      </v-flex>
                    </v-layout>
                  </v-form>
                </v-flex>
              </v-layout>
            </v-card-text>
            <v-card-text>
              <v-alert color="error" icon="error" v-model="errorAlert">{{ errorAlertMessage }}</v-alert>
              <v-alert color="success" icon="check" v-model="successAlert">{{ successAlertMessage }}</v-alert>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn flat @click="$refs.form.reset()">limpiar</v-btn>
              <v-btn
                flat
                color="success"
                @click="submit"
                :loading="loading"
              >buscar</v-btn>
            </v-card-actions>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>
  </v-content>
</template>

<script>
import { forgotPassword } from '@/api/auth'

export default {
  name: 'forgot-password',
  data: function () {
    return {
      errorAlert: false,
      errorAlertMessage: '',
      successAlert: false,
      successAlertMessage: '',
      valid: false,
      loading: false,
      emailAddress: '',
      emailAddressRules: [
        (value) => !!value || 'Correo electrónico requerido',
        (value) => /^([a-z0-9_.-]+)@([a-z0-9.-]+)\.([a-z.]{2,6})$/.test(value) || 'Correo electrónico inválido'
      ]
    }
  },
  methods: {
    submit: async function () {
      if (this.$refs.form.validate()) {
        this.loading = true
        try {
          await forgotPassword({ email: this.emailAddress })
        } catch (e) {
          this.$refs.form.reset()
          this.loading = false
          const message = e.message || 'Ooops, ha ocurrido un error'
          this.errorAlertMessage = message
          this.errorAlert = true
          return false
        }
        this.$refs.form.reset()
        this.loading = false
        this.errorAlert = false
        this.successAlertMessage = 'Revisa tu correo electrónico para continuar con el proceso de recuperación de tu cuenta'
        this.successAlert = true
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/ForgotPassword.vue